export const STORAGE_KEYS = {
  API_CALL_TIME: 'n_act_0',
  PRICE_DATA: 'n_pd_0'
};
